import { useBlockProps } from '@wordpress/block-editor';
import { kebabCase } from "lodash";
import { getChartConfig } from './edit';

export const getAccessibleLabel = (attributes) => {
    const { chartType, chartTitle, xAxis, yAxis, labels, datasets } = attributes;

    let label = `${chartTitle || 'Chart'}: a ${chartType || 'bar'} chart`;

    if (xAxis || yAxis) {
        label += ' ';
        if (xAxis) label += `with X axis "${xAxis}"`;
        if (xAxis && yAxis) { 
            label += ' and ';
            if (yAxis) label += `Y axis "${yAxis}"`;
        } else {
            if (yAxis) label += `with Y axis "${yAxis}"`;
        }
        
    }

    if (labels && labels.length && datasets && datasets.length) {
        // Map each label to its corresponding value(s) in each dataset
        const labelDatasetPairs = labels.map((label, idx) => {
            const values = datasets.map(ds => {
                if (ds && Array.isArray(ds.data)) {
                    // If data exists at this index, use it, else use empty string
                    const value = ds.data[idx] !== undefined ? ds.data[idx] : '';
                    return `${ds.name ? ds.name + ': ' : ''}${value}`;
                }
                return null;
            }).filter(Boolean);
            return `${label} (${values.join(', ')})`;
        });
        label += `. Data points: ${labelDatasetPairs.join('; ')}.`;
    } else if (labels && labels.length) {
        label += `. Labels: ${labels.join(', ')}.`;
    } else if (datasets && datasets.length) {
        const datasetDescriptions = datasets.map(ds => {
            if (ds && ds.name && ds.data && ds.data.length) {
                return `${ds.name} (${ds.data.join(', ')})`;
            } else if (ds && ds.name) {
                return ds.name;
            }
            return null;
        }).filter(Boolean);
        if (datasetDescriptions.length) {
            label += ` Datasets: ${datasetDescriptions.join('; ')}.`;
        }
    }

    return label;
}

export default function Save({ attributes }) {
    
    return (
        <div { ...useBlockProps.save() }>
            <div style={{ position: 'relative', width: '100%', height: 'auto', minHeight: '500px'}}>
                <canvas className="gss-chartjs" data-chartjs-config={JSON.stringify(getChartConfig(attributes))} role="img" aria-labelledby={`${kebabCase(attributes.chartTitle)}-label`}></canvas>
                <div className='gss-chart-label' id={`${kebabCase(attributes.chartTitle)}-label`}>{getAccessibleLabel(attributes)}</div>
            </div>
        </div>)
}